<!-- 新房--详情--楼盘动态 -->
<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <!-- 广告 -->
    <div style="height: 100px"></div>
    <div class="add">
      <div class="addBg"><img :src="advertInfo.image" class="img" @click="linkOut(advertInfo.url)" /></div>
    </div>
    <div class="current">
      <div class="item">
        <span class="font-color-gray">当前位置：首页 > 新房 > 楼盘动态 ></span>
        <span>{{houseDetailAll.name}}</span>
      </div>
    </div>
    <!-- 楼盘首页 -->
    <div class="saleDetail">
      <div class="title">
        <div :class="isIndex == index ? 'title-items' : 'title-item'" v-for="(item, index) in titleList" :key="index" @click="linkPage(item.url, 'id', id)">
          {{ item.typeName }}
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="saleInfo">
      <!-- 左侧 -->
      <div class="sale-left">
        <div style="hight: 10px"></div>
        <div class="flex-s-s message-item" v-for="(item, index) in list" :key="index" @click="linkPage('/messageDetail', 'id', item.id)">
          <div class="left"><img :src="item.avatar" /></div>
          <div class="right">
            <div class="t">{{ item.title }}</div>
            <div class="cont">{{item.introduction}}</div>
            <div class="data-time">发布时间：{{ item.publishTime }}</div>
          </div>
        </div>

        <!-- 翻页 -->
        <div class="pagingBox">
          <div class="paging">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pagesize" layout="prev,pager,next,jumper" :total="total"></el-pagination>
          </div>
        </div>

      </div>
      <!-- 右侧 -->
      <div class="sale-right">
        <div class="title-right">楼讯排行榜</div>
        <div class="right-content">
          <div class="right-item flex-s-c" v-for="(item, index) in articleList" :key="index" @click="linkPage('/messageDetail', 'id', item.id)">
            <div :class="index == 0 || index == 1 || index == 2 ? 'num' : 'nums'">{{ index + 1 }}</div>
            <div class="name ellipsis-one">{{ item.title }}</div>
          </div>
        </div>


        <!-- 帮你看房 -->
        <div class="help-see flex-s-c-fd">
          <div class="title">帮你看房</div>
          <div class="look-select1 ">
            <el-select v-model="inputCity" placeholder="请选择"><el-option v-for="item in shuju" :key="item" :label="item" :value="item"></el-option></el-select>
          </div>
          <div class="input-yi "><el-input v-model="inputMoney" placeholder="首付预算"></el-input></div>
          <div class="input-yi "><el-input v-model="inputName" placeholder="您的称呼"></el-input></div>
          <div class="input-yi "><el-input v-model="inputPhone" placeholder="手机号码"></el-input></div>
          <div class="submit flex-c-c" @click="verifySubmit()">提交</div>
        </div>

        <!-- 二维码 -->
        <div class="erwei-code flex-c-c"><img src="../../../static/pC/erweicode.png" /></div>
      </div>
    </div>

    <!-- 楼盘推荐 -->
    <div class="recommend">
      <div class="t flex-b-c">
        <div>楼盘推荐</div>
        <!-- 导航按钮 -->
        <div class="flex-c-c swiper-button-group">
          <div class="btnswiper next next-gray flex-c-c" v-if="flag1"><img src="../../../static/pC/prev.png" /></div>
          <div class="btnswiper next next-green flex-c-c" v-else><img src="../../../static/pC/prev.png" /></div>
          <div class="btnswiper prev prev-gray flex-c-c" v-if="flag"><img src="../../../static/pC/prev-1.png" /></div>
          <div class="btnswiper prev prev-green flex-c-c" v-else><img src="../../../static/pC/prev-1.png" /></div>
        </div>
      </div>

      <div class="swiper-container card-carousel-cards">
        <div class="swiper-wrapper">
          <div class="swiper-slide card-carousel--card" v-for="(item, index) in recommendList" :key="index" @click="linkPage('/jobDetail', 'id', item.id)">
            <img :src="item.avatar" />
            <div class="n">{{ item.name }}</div>
            <div class="money">{{ item.price }}元/㎡</div>
          </div>
        </div>
      </div>
    </div>


    <!-- 右侧导航 -->
    <RightNav></RightNav>

    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banners from '../../components/Banners.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetCity, apiSunmitOperateIntent } from '../../api/login.js';
import { apiGetEstateArticle, apiGetEstateArticleList } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banners: Banners,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: {},

      shuju: [], //帮你看房--数据
      inputName: '', //帮你看房 -- 输入框 名字
      inputMoney: '', //帮你看房 -- 输入框 预算
      inputPhone: '', //帮你看房 -- 输入框 手机号
      inputCity: '', //帮你看房 -- 下拉框 城市

      isIndex: 5,
      titleList: [
        { typeName: '楼盘首页', url: '/jobDetail' },
        { typeName: '楼盘详情', url: '/SaleDetail' },
        { typeName: '楼盘相册', url: '/BuildImg' },
        { typeName: '户型介绍', url: '/HouseType' },
        { typeName: '用户点评', url: '/evaluate' },
        // { typeName: '周边配套', url: '' },
        { typeName: '楼盘动态', url: '/Dynamics' }
      ],
      list: [],
      articleList:[],
      recommendList:[],
      flag: false, //导航按钮是否到最末尾
      flag1: true ,//导航按钮是否到最开头

      currentPage: 1, //初始页
      pagesize: 10, //每页的数据
      total: 0, //总数
      page: 1, //第几页
      id:'',
      login: false, //是否登录
      userInfo: [] ,//是否登录--用户信息
    };
  },
  created() {
     this.id = this.$route.query.id;
     this.houseDetailAll = JSON.parse(sessionStorage.getItem('houseDetail'));
     this.judgeLogin();
this.getCity();

    this.getState();
    this.getList()
  },
  methods: {
    //帮你找房校验
    verifySubmit() {
      if (this.login) {
        if (this.inputCity == '') {
          this.$message({ message: '请选择城市', type: 'error' });
          return;
        }
        if (this.money == '') {
          this.$message({ message: '请输入首付预算', type: 'error' });
          return;
        }
        if (this.inputName == null || this.inputName == '') {
          this.$message({ message: '请输入您的称呼', type: 'error' });
          return;
        }
        var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!reg.test(this.inputPhone)) {
          this.$message({ message: '请输入正确手机号', type: 'error' });
          return;
        }
        this.sunmitOperateIntent();
      } else {
        this.$message({ message: '请先登录', type: 'error' });
      }
    },

    //帮你找房 -- 提交
    sunmitOperateIntent() {
      let remark = '称呼：' + this.inputName + '_意向区域：' + this.inputCity + '_首付预算：' + this.inputMoney;
      apiSunmitOperateIntent({
        customerId: this.userInfo.id,
        fromWay: '帮你看房',
        remark: remark,
        leavePhone: this.inputPhone
      }).then(res => {
        if (res.success) {
          this.$message({ message: '提交成功', type: 'success' });
          this.inputName = '';
          this.inputMoney = '';
          this.inputPhone = '';
          this.inputCity = '';
        } else {
          this.$message({ message: res.msg, type: 'error' });
        }
        this.$loading().close();
      });
    },

    //帮你找房 -- 获取下拉框
    getCity() {
      apiGetCity({}).then(res => {
        if (res.success) {
          this.shuju = res.data.list;
        } else {
          this.$message({ message: res.msg, type: 'error' });
        }
        this.$loading().close();
      });
    },

    getList() {
       let _this = this;
       apiGetEstateArticleList({
         id: this.id,
         page: this.page,
         limit: this.pagesize
       }).then(res => {
         if (res.success) {
           this.list = res.data.list
            this.total = Number(res.data.count);

         } else {
           this.$message({ message: res.msg, type: 'error' });
         }
       });
    },

    //楼盘动态页静态
    getState() {
      let _this = this;
      apiGetEstateArticle({}).then(res => {
        if (res.success) {
          this.advertInfo = res.data.advertInfo; //广告
          this.articleList = res.data.articleList; //楼讯排行
          this.recommendList = res.data.recommendList; //推荐楼盘

          this.$nextTick(() => {
            //等页面刷新完之后，再执行回调函数中的方法
            var swiper = new Swiper('.swiper-container', {
              slidesPerView: 4,
              spaceBetween: 20,
              loop: false,
              navigation: {
                nextEl: '.prev',
                prevEl: '.next'
              },
              on: {
                slideChangeTransitionEnd: function() {
                  if (this.isEnd) {
                    _this.flag = true;
                  } else {
                    _this.flag = false;
                  }
                  if (this.isBeginning) {
                    _this.flag1 = true;
                  } else {
                    _this.flag1 = false;
                  }
                }
              }
            });
          });
        } else {
          this.$message({ message: res.msg, type: 'error' });
        }
      });
    },

    //翻页
    handleCurrentChange(page) {
      this.page = page;
      this.getList();
    },

    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    },
    
    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },
    


    //跳转页面    url:  页面地址  parame:  参数 key：参数值
    linkPage: function(url, id, key) {
      if (id == '') {
        this.$router.push({ path: url });
      } else {
        this.$router.push({ path: url, query: { id: key }},  onComplete => {}, onAbort => {});
      }
    }
  }
};
</script>
<style scoped>
/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #ffffff;
}
/deep/ .el-select .el-input__inner:focus {
  border-color: #ffffff;
}
/deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 0;
  border: 1px solid #ffffff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #333333;
  display: inline-block;
  font-size: inherit;
  height: 35px;
  line-height: 35px;
  outline: 0;
  padding: 0 18px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 214px;
  font-size: 16px;
}
/* 广告 */
.add {
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
}
.addBg {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.addBg .img {
  width: 100%;
}
/* 当前 */
.current {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #fafafa;
  margin-top: 30px;
  border-bottom: 1px solid #e5e5e5;
}
.current .item {
  max-width: 1200px;
  margin: 0 auto;
  font-size: 14px;
}
/* 楼盘详情 */
.saleDetail {
  max-width: 1200px;
  margin: 30px auto 0 auto;
  display: flex;
}
.saleDetail .title {
  width: 100%;
  background-color: #345c4e;
  color: #fff;
  display: flex;
  align-items: center;
  height: 50px;
}
.saleDetail .title .title-item {
  width: 130px;
  text-align: center;
}
.saleDetail .title .title-items {
  width: 130px;
  text-align: center;
  background-color: #a98c60;
  height: 50px;
  line-height: 50px;
}
/* 导航 */
.saleInfo {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.saleInfo .sale-left {
  width: 840px;
}
.saleInfo .sale-left .title {
  display: flex;
  background-color: #fafafa;
  height: 50px;
}
.saleInfo .sale-left .title .title-item {
  width: 130px;
  height: 50px;
  text-align: center;
  line-height: 46px;
  border-top: 4px solid #fafafa;
  cursor: pointer;
}
.saleInfo .sale-left .title .on {
  background-color: #ffffff;
  border-top: 4px solid #345c4e;
}

/* 资讯列表 */
.message-item {
  margin-top: 30px;
}
.message-item:hover {
  background: #fafafa;
}
.message-item .left {
  min-width: 200px;
}
.message-item .left img {
  width: 200px;
  height: 140px;
}
.message-item .right {
  margin-left: 25px;
}
.message-item .right .t {
  font-size: 18px;
  font-weight: 500;
  color: #333333;
  margin-top: 10px;
}
.message-item .right .cont {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin-top: 15px;
}
.message-item .right .data-time {
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  margin-top: 15px;
}

.saleInfo .sale-right {
  width: 300px;
}
.saleInfo .sale-right .title-right {
  width: 100%;
  text-align: center;
  font-weight: bold;
  height: 50px;
  line-height: 50px;
  background-color: #fafafa;
}

.saleInfo .sale-right .right-content {
  margin-bottom: 40px;
}
.saleInfo .sale-right .right-content .right-item {
  padding: 15px 0;
  border-bottom: 1px dashed #e5e5e5;
}
.saleInfo .sale-right .right-content .right-item .num {
  font-size: 12px;
  min-width: 15px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  background-color: #a98c60;
  color: #fff;
}
.saleInfo .sale-right .right-content .right-item .nums {
  font-size: 12px;
  min-width: 15px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  background-color: #a4a8bb;
  color: #fff;
}
.saleInfo .sale-right .right-content .right-item .name {
  font-size: 14px;
  margin-left: 20px;
}
.saleInfo .sale-right .right-content .right-item .price {
  font-size: 14px;
}
.saleInfo .sale-right .right-content .right-item .area {
  font-size: 14px;
}

/* 帮你看房 */
.help-see {
  width: 285px;
  height: 354px;
  background: linear-gradient(226deg, #64be9f 0%, #345c4e 100%);
  margin-left: 7px;
}
.help-see .title {
  font-size: 20px;
  line-height: 20px;
  color: #ffffff;
  margin-top: 40px;
}
.help-see .look-select1 {
  width: 215px;
  height: 35px;
  margin-top: 15px;
}
.help-see .input-yi {
  height: 35px;
  background-color: #ffffff;
  margin-top: 15px;
}
.help-see .input-yi input {
  width: 100%;
  height: 35px;
}
.help-see .submit {
  width: 110px;
  height: 36px;
  background: #a98c60;
  font-size: 14px;
  line-height: 17px;
  color: #ffffff;
  margin-top: 25px;
}

.erwei-code {
  width: 300px;
  height: 300px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  margin-top: 55px;
}
.erwei-code img {
  width: 284px;
  height: 284px;
}

/* 楼盘推荐 */
.recommend {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 80px;
}
.recommend .t {
  width: 100%;
  font-size: 22px;
  font-weight: bold;
}
.recommend .swiper-button-group {
}
.recommend .swiper-button-group .btnswiper {
  width: 30px;
  height: 30px;
}
.recommend .swiper-button-group .btnswiper img {
  width: 12px;
  height: 20px;
}
.recommend .swiper-button-group .prev {
  margin-left: 20px;
}
.recommend .swiper-button-group .next-gray {
  background: #e5e5e5;
}
.recommend .swiper-button-group .next-green {
  background: #345c4e;
}
.recommend .swiper-button-group .prev-gray {
  background: #e5e5e5;
}
.recommend .swiper-button-group .prev-green {
  background: #345c4e;
}

.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  margin-top: 40px;
}
.card-carousel-cards .card-carousel--card {
  cursor: pointer;
  background-color: #fff;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.card-carousel-cards .card-carousel--card:hover {
  /* box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1); */
}
.card-carousel-cards .card-carousel--card:first-child {
  margin-left: 0;
}
.card-carousel-cards .card-carousel--card:last-child {
  margin-right: 0;
}
.card-carousel-cards .card-carousel--card img {
  max-width: 100%;
  height: 227px;
  vertical-align: bottom;
  display: flex;
}
.card-carousel-cards .card-carousel--card img:hover {
  /* opacity: 0.5; */
}
.card-carousel-cards .card-carousel--card .n {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
}
.card-carousel-cards .card-carousel--card .money {
  font-size: 16px;
  font-weight: bold;
  color: #345c4e;
  margin-top: 20px;
}
.pagingBox {
  max-width: 1400px;
  margin: 35px auto 0 auto;
  margin-bottom: 60px;
}
.pagingBox .paging {
  text-align: center;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/view/Job/Dynamics.vue